import React from "react";

import {Container} from "reactstrap";
import Slider from "./Slider/Slider";
import Slide from "./Slide/Slide";

import incidentDetails from "../../../../img/feature-slides/incident_details.png";
import assetDetails from "../../../../img/feature-slides/asset_details.png";
import assetCalendar from "../../../../img/feature-slides/calendar.png";
import checkList from "../../../../img/feature-slides/service_log.png";
import darkMockup from "../../../../img/IpadPro-dark.png";
import classes from "./FeaturesLayoutsTypeEighteen.module.css"

function FeatureSlides (props) {

    return (
        <React.Fragment>
            <section className={`section ${classes.features} ${(props.dark) ?  `dark ${classes.dark}` : ''}`}>

                <Container className={classes.firstContainer}>
                    <Slider>
                        <Slide>
                            <h1 className="text-center">System Of Record</h1>
                            <p className={`normal-text text-center ${classes.description}`}>
                                All information related to the asset accessible in one place.
                                <br/>No more scrambling for schedule info or product warranty documents.
                            </p>
                            <div className={classes.imageContainer}>
                                <img className={classes.image} src={ props.dark ? darkMockup : assetDetails} alt=""/>
                            </div>
                        </Slide>
                        <Slide>
                            <h1 className="text-center">Maintenance Calendar</h1>
                            <p className={`normal-text ${classes.description} text-center`}>Get a view of maintenance schedules.
                            <br/>
                                Create bulk service requests and assign to service engineers.</p>
                            <div className={classes.imageContainer}>
                                <img className={classes.image} src={ props.dark ? darkMockup : assetCalendar} alt=""/>
                            </div>
                        </Slide>
                        <Slide>
                            <h1 className="text-center">Incident Response With Verification</h1>
                            <p className={`normal-text ${classes.description} text-center`}>Measure incident response time with user verification.
                                <br/>
                                Capture incident triage information for analysis.</p>
                            <div className={classes.imageContainer}>
                                <img className={classes.image} src={ props.dark ? darkMockup : incidentDetails} alt=""/>
                            </div>
                        </Slide>
                        <Slide>
                            <h1 className="text-center">Service Checklist</h1>
                            <p className={`normal-text ${classes.description} text-center`}>
                                Record PM and Calibration activities in service logs.
                                In addition, assign mandatory checklists for each device category.
                            </p>
                            <div className={classes.imageContainer}>
                                <img className={classes.image} src={ props.dark ? darkMockup : checkList} alt=""/>
                            </div>
                        </Slide>
                    </Slider>
                </Container>
            </section>
        </React.Fragment>
    )
}
export default FeatureSlides
